<template>
 <v-dialog v-model="show" persistent max-width="600px">
    <v-card>
                 <v-toolbar
          :color="color +' lighten-3'"
          dark
        >

          <v-toolbar-title   class="headline">{{title}}</v-toolbar-title> 
        </v-toolbar>
            <v-card-text>
              <v-container>
                 <p class="title"  v-if="title=='Närvaro'"> 
                  Har {{name}} varit i skolan idag?
                 </p>
                                  <p class="title"  v-else-if="title=='Medicin'"> 
                 Har {{name}} tagit sina mediciner idag? 
                 </p>
                       <p class="title"  v-else-if="title=='Mat'"> 
                 Har {{name}} ätit mat i skolan idag? 
                 </p>
                       <p class="title"  v-else-if="title=='Sömn'"> 
                 Hur många timmar har {{name}} i natt? 
                 </p>
                <v-flex v-if="empty()==false">
                  <template  v-for="extra in feeling">
                         

                                   <v-tooltip bottom :key="extra.date">
      <template v-slot:activator="{ on }">
       <v-btn  v-on="on"  v-if="title=='Närvaro'"
            class="mx-2"
            fab
            dark
            small
            :color="extra.sch==1?'green ligthen-1':'red ligthen-1'"
          >
         {{ convert(extra.sch)}}
          </v-btn>
                 <v-btn  v-on="on"  v-else-if="title=='Medicin'"
            class="mx-2"
            fab
            dark
            small
            :color="extra.med==1?'green ligthen-1':'red ligthen-1'"
          >
         {{ convert(extra.med)}}
          </v-btn>
                 <v-btn  v-on="on"  v-else-if="title=='Mat'"
            class="mx-2"
            fab
            dark
            small
            :color="extra.food==1?'green ligthen-1':'red ligthen-1'"
          >
         {{ convert(extra.food)}}
          </v-btn>
       <v-btn  v-on="on"  v-else-if="title=='Sömn'"
            class="mx-2"
             fab
            dark
            small
            :color="colors[parseInt(extra.sleep)]"
          >
         
                 {{extra.sleep}}
          </v-btn>
 </template>
      <span>
        
     {{   locfun.getDate(
              extra.date
            )}}
       </span>
    </v-tooltip>
             
                </template>
                </v-flex>
                <v-flex v-else>
                 {{name}} har inte fyllt i någon data än.
                </v-flex>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark color="red darken-1" @click="show = false">
                Stäng
              </v-btn>
            
            </v-card-actions>
          </v-card>
 </v-dialog>
</template>
<script>
import fun from "../functions";
import { mapActions,mapGetters } from "vuex";
export default {
    name:"More",

  computed: {
    show: {
      get () {
        //   if (this.Oldclass!=null) {
        // this.NewFeeling=this.Oldclass;
        //   this.update=true;
        //   }
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    }
  },

    created(){
      
    this.locfun = new fun();
      // if (this.Oldclass!=null) {
      //   this.NewFeeling=this.Oldclass;
     // }
    },
     props:{
    //     membernameandId: Array,
    //     Oldclass: Object,
        color: String,
        feeling: Array,
        name: String,
        title:String,
        value: Boolean
    },
data() {
    return {
        colors: ["red lighten-1","pink lighten-1","purple lighten-2","blue lighten-1","light-green lighten-1","light-green lighten-3","amber lighten-4","amber lighten-3","amber lighten-2","amber lighten-1","amber darken-1","amber darken-2","amber darken-3","amber darken-4","deep-orange darken-1"],
        
      locfun: null,
    };
  }, 

  methods: {
    ...mapActions(['showSuccessSnackbar']),

empty()
{
if (this.title=="Närvaro") {
  let temp = this.feeling.map(function (obj) { return obj.sch; });
   temp = temp.filter(element => {
  return element !== undefined;
});
  return temp.length==0?true:false;
}
else if (this.title=="Medicin") {
  let temp = this.feeling.map(function (obj) { return obj.med; });
   temp = temp.filter(element => {
  return element !== undefined;
});
  return temp.length==0?true:false;
}
else if (this.title=="Mat") {
  let temp = this.feeling.map(function (obj) { return obj.food; });
   temp = temp.filter(element => {
  return element !== undefined;
});
  return temp.length==0?true:false;
}
else if (this.title=="Sömn") {
  let temp = this.feeling.map(function (obj) { return obj.sleep; });
 temp = temp.filter(element => {
  return element !== undefined;
});
  return temp.length==0?true:false;
}

},

convert(input)
{
  if (input=="0") {
    return "Nej"
  }
  return "Ja"

},

  
    
  }
}
</script>
<style >

</style>